import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const PlusIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 20 20", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <rect style={{ fill: "none" }} width="20" height="20" transform="translate(20 20) rotate(-180)" />
            <rect x="9.4" y="2.01" width="1.2" height="16" />
            <rect x="2" y="9.41" width="16" height="1.2" />
        </SvgIcon>
    );
};
